import { gql } from '@apollo/client'

const BASE_PAUSE_TOKEN_FIELDS = gql`
  fragment BasePauseTokenFields on PauseTokenType {
    id
    stripeProductId
    name
    description
    amount
    status
    price
    isMostPopular
    ligthModeImageUrl
    darkModeImageUrl
    active
    platform {
      id
      slug
      title
    }
  }
`

export const FIND_ALL_PAUSE_TOKENS = gql`
  ${BASE_PAUSE_TOKEN_FIELDS}
  query findAllPauseTokens($query: PauseTokenQueryInput!) {
    findAllPauseToken(query: $query) {
      items {
        ...BasePauseTokenFields
      }
      count
    }
  }
`

export const UPDATE_PAUSE_TOKEN = gql`
  ${BASE_PAUSE_TOKEN_FIELDS}
  mutation updatePauseToken($updatePauseTokenInput: UpdatePauseTokenInput!) {
    updatePauseToken(updatePauseTokenInputFieldName: $updatePauseTokenInput) {
      ...BasePauseTokenFields
    }
  }
`

export const FIND_PAUSE_TOKEN = gql`
  ${BASE_PAUSE_TOKEN_FIELDS}
  query findOnePauseToken($pauseTokenId: String!) {
    findOnePauseToken(id: $pauseTokenId) {
      ...BasePauseTokenFields
    }
  }
`
